import {UISprite} from "./UISprite";
import {UIText} from "./UIText";
import {UINineSlice} from "./UINineSlice";

export class UILabeledIcon extends UISprite {
    constructor(props) {
        super();

        if (typeof props === "string") props = { label: props };
        if (typeof props !== "object") props = null;
        let {
            label = "",
            icon = "",
            iconAlign = "left",
            iconSize = 0.5,
            textProps = {},
            backgroundColor = 0x000000,
            backgroundAlpha = 0,
        } = props || {};

        this._back = this.addChild(new UINineSlice("bg-rounding-16px"));
        this._back.tint = backgroundColor;
        this._back.alpha = backgroundAlpha;

        this._label = this.addChild(new UIText(label || "", textProps || {}));

        let iconObj = icon;
        if (!icon || typeof icon === "string") {
            iconObj = new UISprite(icon);
        }
        this._icon = this.addChild(iconObj);
        this._rect = new PIXI.Rectangle();
        this.iconAlign = iconAlign;
        this.iconSize = iconSize;

        this._icon.SetActive(!!icon);
        this._initialFit();
    }

    _initialFit() {
        let h = this._label.textHeight;
        let w = this._label.textWidth;
        if (this._icon.Active) {
            this._icon.fitRect(new PIXI.Rectangle(0, 0, h, h));
            w += this._icon.width;
        }
        this.fitLayout(new PIXI.Rectangle(0, 0, w, h));
    }

    get backgroundColor() {
        return this._back.tint;
    }

    set backgroundColor(val) {
        this._back.tint = val;
    }

    get backgroundAlpha() {
        return this._back.alpha;
    }

    set backgroundAlpha(val) {
        this._back.alpha = val;
    }

    get label() {
        return String(this._label.text);
    }

    set label(val) {
        this._label.text = String(val);
        this.fitLayout();
    }

    get text() {
        return this.label;
    }

    set text(val) {
        this.label = val;
    }

    get icon() {
        return this._icon.texture;
    }

    set icon(val) {
        this._icon.setImage(val);
        this.fitLayout();
    }

    _fitChildren() {

        this._icon.SetActive(this._icon.texture !== PIXI.Texture.EMPTY);

        let iconAlign = this.iconAlign.split("-").pop();
        let iconAbsolute = this.iconAlign.startsWith("absolute-");

        let rect = this._rect.clone();
        rect.x = rect.y = 0;

        this._back.fitLayout(rect);

        let labelRect = new PIXI.Rectangle(0, 0, 0, 0);
        let iconRect = new PIXI.Rectangle(0, 0, 0, 0);

        let padding = this._icon.Active ? Math.min(rect.width * 0.05, 10) : 0;

        // Fit icon if not empty
        if (this._icon.Active) {
            let boxSize = rect.height * this.iconSize;
            let min = Math.min(boxSize / this._icon.texture.width, boxSize / this._icon.texture.height);

            iconRect.width = this._icon.texture.width * min;
            iconRect.height = this._icon.texture.height * min;
            iconRect.x = (rect.width - iconRect.width) * 0.5;
            iconRect.y = (rect.height - iconRect.height) * 0.5;
        }

        // Fit label if not empty
        if (!!this._label.text.length) {
            labelRect.width = rect.width - iconRect.width - padding;
            labelRect.height = rect.height;

            this._label.fitLayout(labelRect);

            // Adjust sizes for horizontal distribution
            labelRect.width = this._label.textWidth * this._label.scale.x;
            // labelRect.height = this._label.textHeight * this._label.scale.y;
            labelRect.height = this._label.getLocalBounds().height * this._label.scale.y;
            labelRect.x = (rect.width - labelRect.width) * 0.5;
            labelRect.y = (rect.height - labelRect.height) * 0.5;
        }

        if (iconAbsolute) {
            iconRect.x = iconAlign === "right" ? rect.width - iconRect.width : 0;
            labelRect.x = iconAlign === "right" ? 0 : iconRect.x + iconRect.width + padding;
        } else {
            let elements = iconAlign === "right" ? [labelRect, iconRect] : [iconRect, labelRect];
            let totalWidth = elements.reduce((res, { width }) => res + width, 0) + (elements.length - 1) * padding;

            let x = rect.x + (rect.width - totalWidth) * 0.5;
            for (let el of elements) {
                el.x = x;
                x += el.width + padding;
            }
        }

        this._icon.fitRect(iconRect);
        this._label.fitLayout(labelRect);

        // Uncomment this for rects DEBUG
        // this.__g = (this.__g || this.addChild(new PIXI.Graphics()))
        //     .clear()
        //     .lineStyle(1, 0xff0000)
        //     .drawRect(labelRect.x, labelRect.y, labelRect.width, labelRect.height)
        //     .lineStyle(1, 0x0000ff)
        //     .drawRect(iconRect.x, iconRect.y, iconRect.width, iconRect.height)
        //     .lineStyle(1, 0x00ff00)
        //     .drawRect(rect.x, rect.y, rect.width, rect.height);
    }

    fitLayout(rect = this._rect) {
        this._rect.copyFrom(rect);
        this.position.copyFrom(rect);
        this._fitChildren();
    }
}
